// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: room_int.proto

/* eslint-disable */

export const protobufPackage = "usertracking.v3";

export interface RoomInt {
  id: number;
  type_id: number;
  title: string;
  available_rooms: number;
  base_price: number;
  local_price: number;
  local_price_off: number;
  original_sell_price: number;
  bed_price: number;
  child_price: number;
  has_foreign_guest: boolean;
  extra_bed: number;
  breakfast_included: boolean;
  adult: number;
  child: number;
  child_age: number;
  infant_age: number;
  adult_reserved: number;
  child_reserved: number;
}

function createBaseRoomInt(): RoomInt {
  return {
    id: 0,
    type_id: 0,
    title: "",
    available_rooms: 0,
    base_price: 0,
    local_price: 0,
    local_price_off: 0,
    original_sell_price: 0,
    bed_price: 0,
    child_price: 0,
    has_foreign_guest: false,
    extra_bed: 0,
    breakfast_included: false,
    adult: 0,
    child: 0,
    child_age: 0,
    infant_age: 0,
    adult_reserved: 0,
    child_reserved: 0,
  };
}

export const RoomInt: MessageFns<RoomInt> = {
  fromJSON(object: any): RoomInt {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      type_id: isSet(object.type_id) ? globalThis.Number(object.type_id) : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      available_rooms: isSet(object.available_rooms) ? globalThis.Number(object.available_rooms) : 0,
      base_price: isSet(object.base_price) ? globalThis.Number(object.base_price) : 0,
      local_price: isSet(object.local_price) ? globalThis.Number(object.local_price) : 0,
      local_price_off: isSet(object.local_price_off) ? globalThis.Number(object.local_price_off) : 0,
      original_sell_price: isSet(object.original_sell_price) ? globalThis.Number(object.original_sell_price) : 0,
      bed_price: isSet(object.bed_price) ? globalThis.Number(object.bed_price) : 0,
      child_price: isSet(object.child_price) ? globalThis.Number(object.child_price) : 0,
      has_foreign_guest: isSet(object.has_foreign_guest) ? globalThis.Boolean(object.has_foreign_guest) : false,
      extra_bed: isSet(object.extra_bed) ? globalThis.Number(object.extra_bed) : 0,
      breakfast_included: isSet(object.breakfast_included) ? globalThis.Boolean(object.breakfast_included) : false,
      adult: isSet(object.adult) ? globalThis.Number(object.adult) : 0,
      child: isSet(object.child) ? globalThis.Number(object.child) : 0,
      child_age: isSet(object.child_age) ? globalThis.Number(object.child_age) : 0,
      infant_age: isSet(object.infant_age) ? globalThis.Number(object.infant_age) : 0,
      adult_reserved: isSet(object.adult_reserved) ? globalThis.Number(object.adult_reserved) : 0,
      child_reserved: isSet(object.child_reserved) ? globalThis.Number(object.child_reserved) : 0,
    };
  },

  toJSON(message: RoomInt): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.type_id !== 0) {
      obj.type_id = Math.round(message.type_id);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.available_rooms !== 0) {
      obj.available_rooms = Math.round(message.available_rooms);
    }
    if (message.base_price !== 0) {
      obj.base_price = Math.round(message.base_price);
    }
    if (message.local_price !== 0) {
      obj.local_price = Math.round(message.local_price);
    }
    if (message.local_price_off !== 0) {
      obj.local_price_off = Math.round(message.local_price_off);
    }
    if (message.original_sell_price !== 0) {
      obj.original_sell_price = Math.round(message.original_sell_price);
    }
    if (message.bed_price !== 0) {
      obj.bed_price = Math.round(message.bed_price);
    }
    if (message.child_price !== 0) {
      obj.child_price = Math.round(message.child_price);
    }
    if (message.has_foreign_guest !== false) {
      obj.has_foreign_guest = message.has_foreign_guest;
    }
    if (message.extra_bed !== 0) {
      obj.extra_bed = Math.round(message.extra_bed);
    }
    if (message.breakfast_included !== false) {
      obj.breakfast_included = message.breakfast_included;
    }
    if (message.adult !== 0) {
      obj.adult = Math.round(message.adult);
    }
    if (message.child !== 0) {
      obj.child = Math.round(message.child);
    }
    if (message.child_age !== 0) {
      obj.child_age = Math.round(message.child_age);
    }
    if (message.infant_age !== 0) {
      obj.infant_age = Math.round(message.infant_age);
    }
    if (message.adult_reserved !== 0) {
      obj.adult_reserved = Math.round(message.adult_reserved);
    }
    if (message.child_reserved !== 0) {
      obj.child_reserved = Math.round(message.child_reserved);
    }
    return obj;
  },

  create(base?: DeepPartial<RoomInt>): RoomInt {
    return RoomInt.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoomInt>): RoomInt {
    const message = createBaseRoomInt();
    message.id = object.id ?? 0;
    message.type_id = object.type_id ?? 0;
    message.title = object.title ?? "";
    message.available_rooms = object.available_rooms ?? 0;
    message.base_price = object.base_price ?? 0;
    message.local_price = object.local_price ?? 0;
    message.local_price_off = object.local_price_off ?? 0;
    message.original_sell_price = object.original_sell_price ?? 0;
    message.bed_price = object.bed_price ?? 0;
    message.child_price = object.child_price ?? 0;
    message.has_foreign_guest = object.has_foreign_guest ?? false;
    message.extra_bed = object.extra_bed ?? 0;
    message.breakfast_included = object.breakfast_included ?? false;
    message.adult = object.adult ?? 0;
    message.child = object.child ?? 0;
    message.child_age = object.child_age ?? 0;
    message.infant_age = object.infant_age ?? 0;
    message.adult_reserved = object.adult_reserved ?? 0;
    message.child_reserved = object.child_reserved ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
